<template>
    <div class="grcform">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="grc_fullwidth_lane">
            <div class="grc_maincont_lane" style="padding-left: 4px;">
              <div class="grc_sectionheader" style="margin-top:10px; margin-bottom:10px;">
                  <span class="line color1">
                    <span class="title_general" style="padding-left:10px !important;">
                      {{title}}
                      </span>
                  </span>
              </div>
            </div>
        </div>

        <div class="grc_fullwidth_lane">
        <div class="grc_maincont_lane" style="padding:10px;">

            <div class="main_col_cont">
                <div class="main_col">
                    <div class="innerform" v-show="innerformid==1">

                        <GrcKartyaszam ref="txtKartyaszam" grc_labeltext="Kártyaszám:" grc_placeholder="..."
                        grc_labelmode="" grc_labelwidth="200px" 
                        v-on:grc-keydown-enter="SetControlToFocus('txtSzuletesiIdo');"
                        style="margin-bottom:20px;"
                        />


                        <GrcDate ref="txtSzuletesiIdo" v-model="SzuletesiIdo" grc_dateformat="ymd" grc_sep="." 
                        grc_labeltext="Születési idő:" grc_labelmode="" grc_labelwidth="200px" grc_readonly="false"
                        v-on:grc-keydown-enter="SetControlToFocus('txtAdoazon');"
                        v-on:dropdownopened="SetPopupRef('txtSzuletesiIdo')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        style="margin-bottom:20px;"
                        />

                        <GrcAdoazon ref="txtAdoazon" v-model="adoazon"
                        grc_labeltext="Adóazonosító jel:" grc_labelmode="" grc_labelwidth="200px"
                        v-on:grc-keydown-enter="SetControlToFocus('');"
                        style="margin-bottom:20px;"
                        />


                        <div class="btn_cont">

                            <GrcButton grc_text="Aktiválom a kártyát" @grc-click="btnAktivalas_click" grc_readonly="false" 
                            grc_color="blue" grc_shadow="false" grc_radius="2px" grc_width="200px"
                            grc_buttonpos="left"
                            grc_textalign="center"
                            grc_lefticon="<i class='fas fa-check'></i>"
                            style="display:inline-block;" />                    

                        </div>

                    </div>
                    <div class="innerform" v-show="innerformid==2">
                        <div class="infotext" v-html="sikeres_text" />
                        <div class="infotext" style="margin-top: 20px;" v-html="sikeres_befiz_text" />
                        <div class="infotext" style="margin-top: 20px;" v-html="sikeres_reg_text" v-show="VanPortalReg==0" />
                        <div class="infotext" style="margin-top: 20px;" v-html="sikeres_csoda_text" v-show="VanPortalReg==1&&Csodasitva==0" />
                    </div>



                </div>
                <div class="main_col">
                    <div class="infotext" v-html="infotext" />
                </div>
            </div>
            





        </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcAdoazon from '../GrcComponents/GrcAdoazon.vue'
import GrcKartyaszam from '../GrcComponents/GrcKartyaszam.vue'


export default {
  name: 'frmKartyaAktivalas',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcDate,
      GrcAdoazon,
      GrcKartyaszam
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmKartyaAktivalas",
            gPopupControlName:"",

            innerformid:1,
            title:"",
            infotext:"",
            sikeres_text:"",
            sikeres_reg_text:"",
            sikeres_csoda_text:"",
            sikeres_befiz_text:"",
            VanPortalReg:0,
            Csodasitva:0,

            SzuletesiIdo:"",
            adoazon:"",
            
      }
  },
  model: {
  },  
  methods:{

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmKartyaAktivalas", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }

        this.$refs[pNextComp].SetFocus();
    },


    SetLang()
    {
        this.title = this.GetTextBookItem("title");
        this.infotext = this.GetTextBookItem("info_text");
        this.sikeres_text = this.GetTextBookItem("sikeres_text");
        this.sikeres_reg_text = this.GetTextBookItem("sikeres_reg_text");
        this.sikeres_csoda_text = this.GetTextBookItem("sikeres_csoda_text");
        this.sikeres_befiz_text = this.GetTextBookItem("sikeres_befiz_text");

        this.Init();
    },

      HideErrors()
      {
        //this.$refs.ErrorBox.HideError();
        this.$refs.txtKartyaszam.HideError();
        this.$refs.txtSzuletesiIdo.HideError();
        this.$refs.txtAdoazon.HideError();
      },

    async btnAktivalas_click()
    {
        this.HideErrors();

        var ErrorCompName = "";

        if (this.$refs.txtKartyaszam.GetText().length < 16)
        {
            if (ErrorCompName == "") { ErrorCompName = "txtKartyaszam"; }
            this.$refs.txtKartyaszam.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtSzuletesiIdo.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtSzuletesiIdo"; }
          this.$refs.txtSzuletesiIdo.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtAdoazon.GetText() == '')
        {
          if (ErrorCompName == "") { ErrorCompName = "txtAdoazon"; }
          this.$refs.txtAdoazon.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (ErrorCompName != "")
        {
          this.SetControlToFocus(ErrorCompName);
          return;
        }

        this.Aktivalas();

    },

    async Aktivalas()
    {
        this.scrollToTop();


        this.$refs.GRCDB.ShowLoading(false);

        var QP = {
            sKartyaszam: this.$refs.txtKartyaszam.GetText(),
            sSzuletesiIdo: this.$refs.txtSzuletesiIdo.GetText(),
            sAdoazon: this.$refs.txtAdoazon.GetText(),
        };
        var Q;
        await this.$refs.GRCDB.GetData("frmKartyaAktivalas_Aktivalas", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {

            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200");
            }
            return;
        }

        this.$refs.GRCDB.HideLoading();
        
        if (Q.RESULT[0].intResult != 1)
        {
            this.ShowInfoDialog(Q.RESULT[0].strResult, 200);
            return;
        }

        this.VanPortalReg = Q.RESULT[0].VanPortalReg;
        this.Csodasitva = Q.RESULT[0].Csodasitva;

        this.innerformid = 2;

    },


    async Init()
    {
        this.InfoText = "";

    },


    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.maintitle
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "PremiumDefault";
    font-size:22px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px;
}

.main_col_cont
{
    width:100%;
    box-sizing: border-box;
}

.main_col
{
    width:50%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
}

.innerform
{
    width:100%;
    box-sizing: border-box;
}

.infotext
{
    width: 100%;
    box-sizing: border-box;
    color: #323232;
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: justify;
    padding: 0px 10px 0px 20px;
}

div >>> .info_title
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:18px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px 0px;
    font-weight: 500;
}


.btn_cont
{
  width:100%;
  box-sizing: border-box;
  padding:4px 0px;
  border-top:solid 0px #ccc;
  margin-top: 0px;
  text-align: center;
}

.btn
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
}

.btn_gray2
{
  background-color: #ccc;
  color:#222;
}

.btn:hover
{
  background-color: var(--premgreen);
  color:#fff;
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.btn_gray:hover
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}


div >>> .btnLink
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
  text-decoration: none;
}


div >>> .btnLink:visited
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
  text-decoration: none;
}


div >>> .btnLink:hover
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premgreen);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;
  text-decoration: none;

}



@media (max-width:900px)
{
    .infotext
    {
        font-size:14px;
        line-height: 18px;
    }

}

@media (max-width:700px)
{
    .main_col
    {
        width:100%;
    }

    .infotext
    {
        font-size:14px;
        line-height: 18px;
        padding: 30px 0px 20px 0px;
    }
}


</style>